export default __webpack_public_path__ + "static/media/logout-icon.1a16fdd5.svg";